import { render, staticRenderFns } from "./InviteList.vue?vue&type=template&id=8a1b562e&scoped=true&"
import script from "./InviteList.vue?vue&type=script&lang=js&"
export * from "./InviteList.vue?vue&type=script&lang=js&"
import style0 from "./InviteList.vue?vue&type=style&index=0&id=8a1b562e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b562e",
  null
  
)

export default component.exports